import {Fragment, useEffect} from 'react';
import './index.css';

function AndroidPageSm() {
    useEffect(() => {
        window.location.replace('https://milocal.cencosud.com/android')
    }, []);

    return <Fragment>
        <div className="android-page">
            <div className="content">
                <img src="assets/img/android-sm/1.png" alt=""/>
                <a className='btndownload'
                   href=""
                   target="_self">
                    <img src="assets/img/android-sm/2.png" alt=""/>
                </a>
                <img className='mb-2 card' src="assets/img/android-sm/3.png" alt=""/>
                <img className='mb-2 card' src="assets/img/android-sm/4.png" alt=""/>
                <img className='mb-2 card' src="assets/img/android-sm/5.png" alt=""/>
                <img className='mb-2' src="assets/img/android-sm/6.png" alt=""/>
            </div>
        </div>
    </Fragment>
}

export default AndroidPageSm;
